import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { CommonComponentsModule } from "components/common/common-components.module";
import { ComponentsModule } from "components/components.module";
import { IonicModule } from "ionic-angular";
import { TruncateModule } from "ng2-truncate";
import { EPrescribeIFrame } from "./eprescribe.component";

@NgModule({
  entryComponents: [],
  declarations: [EPrescribeIFrame],
  imports: [
    TranslateModule.forChild(),
    CommonComponentsModule,
    NgSelectModule,
    ComponentsModule,
    TruncateModule,
    CommonModule,
    IonicModule,
  ],
  exports: [EPrescribeIFrame],
})
export class EPrescribeComponentModule {}



// WEBPACK FOOTER //
// ./src/components/eprescribe/eprescribe.component.module.ts